import { getStorageEntity } from '../storage';
import { IStorageEntity } from "../storage/interface";

export const AUTH_ACCESS_TOKEN_KEY: string = 'token';
export const AUTH_REFRESH_TOKEN_KEY: string = 'rToken';
export const IS_AUTH_KEY: string = 'isAuth';

export const authAccessTokenEntity: IStorageEntity = getStorageEntity(AUTH_ACCESS_TOKEN_KEY, 'cookie');
export const authRefreshTokenEntity: IStorageEntity = getStorageEntity(AUTH_REFRESH_TOKEN_KEY, 'cookie');

export const authAccessTokenSessionEntity: IStorageEntity = getStorageEntity(AUTH_ACCESS_TOKEN_KEY, 'sessionStorage');
export const authRefreshTokenSessionEntity: IStorageEntity = getStorageEntity(AUTH_REFRESH_TOKEN_KEY, 'sessionStorage');

export const isAuthEntity: IStorageEntity = getStorageEntity(IS_AUTH_KEY, 'localStorage');